import React from 'react';
import {
	Flex,
	Popover,
	Typography,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKeyboard } from '@fortawesome/pro-light-svg-icons';

const SHORTCUTS = [
	{ keys: 'Enter', action: 'Save field and move down' },
	{ keys: 'Shift + Enter', action: 'Save field and move up' },
	{ keys: 'Tab', action: 'Move right' },
	{ keys: 'Shift + Tab', action: 'Move left' },
	{ keys: 'Esc', action: 'Revert field' },
	{ keys: 'Ctrl / ⌘ + S', action: 'Save & Calculate' },
];

const SpreadsheetNavigationHint = () => (
	<Popover
		title="Keyboard shortcuts"
		content={(
			<Flex vertical gap={4}>
				{SHORTCUTS.map(({ keys, action }) => (
					<Flex key={keys} justify="space-between" gap={24}>
						<Typography.Text keyboard>{keys}</Typography.Text>
						<Typography.Text>{action}</Typography.Text>
					</Flex>
				))}
			</Flex>
		)}
	>
		<Typography.Text type="secondary" data-testid="spreadsheet-navigation-hint">
			<FontAwesomeIcon icon={faKeyboard} />
			{' '}
			Keyboard shortcuts
		</Typography.Text>
	</Popover>
);

export default SpreadsheetNavigationHint;
